import { render, staticRenderFns } from "./ScrapRegistrationEdit.vue?vue&type=template&id=5259c13e&scoped=true"
import script from "./ScrapRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./ScrapRegistrationEdit.vue?vue&type=script&lang=js"
import style0 from "./ScrapRegistrationEdit.vue?vue&type=style&index=0&id=5259c13e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5259c13e",
  null
  
)

export default component.exports